import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=ad144f34&scoped=true&"
import script from "./Window.vue?vue&type=script&lang=js&"
export * from "./Window.vue?vue&type=script&lang=js&"
import style0 from "./Window.vue?vue&type=style&index=0&id=ad144f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad144f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad144f34')) {
      api.createRecord('ad144f34', component.options)
    } else {
      api.reload('ad144f34', component.options)
    }
    module.hot.accept("./Window.vue?vue&type=template&id=ad144f34&scoped=true&", function () {
      api.rerender('ad144f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Message/Detail/Window.vue"
export default component.exports